import React, { useState, useEffect } from "react";

import $ from 'jquery';
import "../../assets/css/dist/organograma.dist.css?v=1";
import '../../assets/js/src/components/organograma.js';
import api from "../Services/api";

/*
Title															Area
------------------------------------------------------------------------------------------------------------------														
0: "Conselho Deliberativo    									conselho-deliberativo"
1: "Gerência de Complience e Governança (FPR/CO)    			gerencia-de-complience-e-governacao-fpr-co"
2: "Conselho Fiscal    											conselho-fiscal"
3: "Presidência (FPR)    										presidencia-fpr"
4: "Consultoria Jurídica (FPR/CJ)    							consultoria-juridica-fpr-cj"
5: "Gerência de Comunicação e Atendimento (FPR/CA)    			gerencia-de-comunicacao-e-atendimento-fpr-ca"
6: "Assessoria de Risco (FPR/RI)    							assessoria-de-risco-fpr-ri "
7: "Diretoria de Investimentos e Controle (FIC)    				diretoria-de-investimentos-e-controle-fic"
8: "Gerência de Renda Variável de Macroalocação (FIC/RV)    	gerencia-de-renda-variavel-de-macroalocação-fic-rv"
9: "Gerência de Controladoria e Finanças (FIC/CF)    			gerencia-de-controladoria-e-financas-fic-cf"
10: "Gestão de Renda Fixa, Imóveis e Empréstimos (FIC/RF)    	gestao-de-renda-fixa-imoveis-e-emprestimos-fic-rf"
11: "Diretoria de Seguridade e Gestão (FSG)    					diretoria-de-seguridade-e-gestao-fsg"
12: "Gerência de Atuária e Seguridade (FSG/AS)    				gerencia-de-atuaria-e-seguridade-fsg-ad"
13: "Gerência de Tecnologia da Informação (FSG/TI)    			gerencia-de-tecnologia-da-informacao-fsg-ti"
14: "Gerência de Recursos Humanos e Administração (FSG/RA)		gerencia-de-recursos-humanos-e-administracao-fsg-ra"
15: "Diretoria de Relações com Participantes (FRP)    			diretoria-de-relacoes-com-participantes-frp"
*/

// get user click in the page jquery

const Card = (props: any) => {

	const setActive = (id: any) => {
		$(".organograma__item").removeClass("active");
		$(".card").css({ "display": "none" });
		$("#" + id).addClass("active");
		$("#subBox" + id).css("display", "block");
		$("#subBox" + id).addClass("showCard");
	}

	let item = props.item;

	return (
		<div onClick={() => setActive(item.BoxId)} id={item.BoxId} className={"organograma__item " + props.class}>

			<>

				<p> {item.Title} </p>

				<div id={"subBox" + item.BoxId} className="content text-white card" >

					<p> <strong> {item.Title} </strong> </p>
					<p>
						{item.Descricao}
					</p>
				</div>
			</>

		</div>
	);
}

const Organograma = () => {

	const [organograma, setOrganograma] = useState<any[]>([]);
	
	$('#OrganogramaDiv').off().on('click', function () {
		$(".organograma__item").removeClass("active");
		$(".card").css({ "display": "none" });
	});
	$('#OrganogramaDivUpper').off().on('click', function () {
		$(".organograma__item").removeClass("active");
		$(".card").css({ "display": "none" });
	});
	useEffect(() => {
		api
			.get("/ObterOrganograma")
			.then((response) => {
				setOrganograma(response.data.results);
				console.log("organograma :", response.data.results)
			})
			.catch((err: string) => {
				throw new Error(err);
			});
	}, []);

	return (

		<div className="organograma pb-lg-10">
			<div className='container'>
				<div id="OrganogramaDivUpper" className='row justify-content-center'>
					<div id="OrganogramaDiv" className='col-lg-10 d-none d-lg-block'>

						<div className="organograma__row justify-content-center deliberativo">
							{organograma?.filter(box => box.BoxId === 1).map(item => (
								<Card item={item} key={item.Id}/>
							))}
						</div>

						<div className="organograma__row justify-content-between compilance2">
							<div className="organograma__row2 compilance3">
								{organograma?.filter(box => box.BoxId === 2).map(item => (
									<Card item={item} key={item.Id} />
								))}
							</div>
							<div className="compilance3" style={{ borderStyle: "dashed", borderColor: "lightgray" }}>
								{organograma?.filter(box => box.BoxId === 3).map(item => (
									<Card item={item} key={item.Id} />
								))}
							</div>
						</div>


						<div className="organograma__row justify-content-between risco2">
							{organograma?.filter(box => box.BoxId === 17).map(item => (
								<Card item={item} key={item.Id} />
							))}
						</div>

						<div className="organograma__row justify-content-center presidencia">
							{organograma?.filter(box => box.BoxId === 4).map(item => (
								<Card item={item} key={item.Id} />
							))}
						</div>
						{/* */}
						<div className="organograma__row justify-content-between compilance">
							{organograma?.filter(box => box.BoxId === 5).map(item => (
								<Card item={item} key={item.Id} />
							))}

							{organograma?.filter(box => box.BoxId === 6).map(item => (
								<Card item={item} key={item.Id} />
							))}
						</div>
						<div className="organograma__row justify-content-between compilance">
							{organograma?.filter(box => box.BoxId === 7).map(item => (
								<Card item={item} key={item.Id} />
							))}

							{organograma?.filter(box => box.BoxId === 18).map(item => (
								<Card item={item} key={item.Id}/>
							))}
						</div>


						<div className="organograma__row justify-content-between diretoria large">
							<div>
								{organograma?.filter(box => box.BoxId === 8).map(item => (
									<Card item={item} key={item.Id} />
								))}
								<div className="child">

									{organograma?.filter(box => box.BoxId === 9).map(item => (
										<Card item={item} key={item.Id} class={"ml-lg-7 mt-7"} />
									))}


									{organograma?.filter(box => box.BoxId === 10).map(item => (
										<Card item={item} key={item.Id} class={"ml-lg-7 mt-7"} />
									))}

									{organograma?.filter(box => box.BoxId === 11).map(item => (
										<Card item={item} key={item.Id} class={"ml-lg-7 mt-7"} />
									))}
								</div>
							</div>

							<div>

								{organograma?.filter(box => box.BoxId === 12).map(item => (
									<Card item={item} key={item.Id} />
								))}

								<div className="child">

									{organograma?.filter(box => box.BoxId === 13).map(item => (
										<Card item={item} key={item.Id} class={"ml-lg-7 mt-7"} />
									))}

									{organograma?.filter(box => box.BoxId === 14).map(item => (
										<Card item={item} key={item.Id} class={"ml-lg-7 mt-7"} />
									))}

									{organograma?.filter(box => box.BoxId === 15).map(item => (
										<Card item={item} key={item.Id} class={"ml-lg-7 mt-7"} />
									))}

								</div>
							</div>

							{organograma?.filter(box => box.BoxId === 16).map(item => (
								<Card item={item} key={item.Id}/>
							))}

						</div>

					</div>
					<div className="col-12 d-lg-none">
						<a href="\DOCS\Organograma\Novo organograma Portal-01.pdf" className="link-organograma pb-6 d-block">
							<img src="../assets/img/organograma/img-org.png" alt="Organograma" className="mb-5" />

							<span> <strong> Organograma </strong> </span> <br />
							<span className="d-flex w-100 align-items-center my-4" >
								<span className="ico">
									<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"  >
										<circle cx="12" cy="12" r="12" fill="#E0E0E0" />
										<g  >
											<rect x="4" y="3" width="16" height="16" fill="url(#pattern0)" />
										</g>
										<defs>
											<pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
												<use transform="translate(-0.851563 -0.896277) scale(0.00260417)" />
											</pattern>
										</defs>
									</svg>
								</span>
								<span className="text ml-3">
									Organograma - 3,63MB
								</span>
							</span>
						</a>
					</div>
				</div>

			</div>

		</div>

	);

};
export default Organograma;